import React, { useEffect, useRef } from "react";
import { Toast } from "primereact/toast";
import { SpeedDial } from "primereact/speeddial";
import EmojiPicker from "emoji-picker-react";
import TypingLoader from "../../../sharedComponent/TypingLoader ";
import Mensions from "../../../sharedComponent/mesnsion/Mesnsion";
import send_btn from "../../../assets/images/chat/send_btn.svg";
import ReplyBanner from "./ReplyBanner";

const Composer = ({
  emogi,
  setEmogi,
  message,
  setmessage,
  uploadedFiles,
  setUploadedFiles,
  replyTo,
  setReplyTo,
  menstionedUsers,
  setMenstionedUsers,
  inputRef,
  msgRef,
  recentChats,
  setRecentChats,
  pinnedChats,
  setPinnedChats,
  activeChat,
  sendMessage,
  userTyping,
  userData,
  currentSChannel,
  toast,
  items,
}) => {
  const emojiPickerRef = useRef(null);

  useEffect(() => {
    if (!emogi) return undefined;

    const handleClickOutside = (event) => {
      if (
        emojiPickerRef.current &&
        !emojiPickerRef.current.contains(event.target) &&
        !event.target.closest(".comm-composer__attach")
      ) {
        setEmogi(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") setEmogi(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [emogi, setEmogi]);

  return (
      <div>
        <div className="comm-chatbox__typing-area">
          {userTyping.status === true &&
            userTyping?.EmpId != userData?.EmpId &&
            userTyping.currentSChannel == currentSChannel && (
              <div className="d-flex">
                {" "}
                <p className="comm-chatbox__typing-text">
                  {" "}
                  {userTyping?.userName + " is typing"}
                </p>{" "}
                <TypingLoader />{" "}
              </div>
            )}
        </div>
        <ReplyBanner
          replyTo={replyTo}
          setReplyTo={setReplyTo}
          msgRef={msgRef}
        />
        <div className="comm-composer">
          {emogi && (
            <div
              className="comm-composer__emoji-picker"
              ref={emojiPickerRef}
            >
              <button
                type="button"
                className="comm-composer__emoji-close"
                aria-label="Close emoji picker"
                onClick={() => setEmogi(false)}
              >
                <i className="pi pi-times" />
              </button>
              <EmojiPicker
                onEmojiClick={(e) => {
                  setmessage(message + e.emoji);
                }}
                width={320}
                height={380}
                searchPlaceHolder="Search"
                previewConfig={{ showPreview: false }}
                lazyLoadEmojis
              />
            </div>
          )}
          <div className="comm-composer__attach">
            {/* <SpeedDial
            model={items}
            direction='up'
            onClick={() => setEmogi(false)}
          /> */}
            <Toast ref={toast} />
            <SpeedDial model={items} direction="up" />
          </div>
          <div className="comm-composer__input-wrapper">
            <Mensions
              setEmogi={setEmogi}
              replyTo={replyTo}
              setUploadedFiles={setUploadedFiles}
              sendMessage={sendMessage}
              uploadedFiles={uploadedFiles}
              message={message}
              setMessage={setmessage}
              menstionedUsers={menstionedUsers}
              setMenstionedUsers={setMenstionedUsers}
              inputRef={inputRef}
              recentChats={recentChats}
              setRecentChats={setRecentChats}
              pinnedChats={pinnedChats}
              setPinnedChats={setPinnedChats}
              activeChat={activeChat}
            />

            {/* <input
          type="text"
          className="form-control"
          placeholder="Type a message here"
          onChange={(e) => {
            typing();
            setmessage(e.target.value)
          }}
          
          onBlur={() => stopTyping()}
          value={message}
        /> */}
          </div>
          {/* <div className="send-btn">
          <img
            src={mic}
            onClick={() => {
              checkMicrophoneConnection();
            }}
            alt="mic"
          />
        </div> */}
          <div
            className={`comm-composer__send${
              !message.length && !uploadedFiles.length
                ? " comm-composer__send--inactive"
                : ""
            }`}
            onClick={(e) => {


              if (message.length || uploadedFiles.length) {
                setEmogi(false);
                sendMessage(
                  message,
                  [...uploadedFiles],
                  replyTo,
                  menstionedUsers
                );
                setUploadedFiles([]);
                setReplyTo({});
                setmessage("");
                setMenstionedUsers([]);
              }
              // if (menstionedUsers?.[0]?.display == "Vehicle Ai assistant" || ChatBotAiData.FirstName == "Vehicle") {
              //   chatbotapicall(message, ChatBotAiData.User_Id)

              // }
            }}
          >
            <img src={send_btn} alt="" />
          </div>
        </div>
      </div>
  );
};

export default Composer;
